var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "briefcase",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M7,2C6.4,2,6,2.4,6,3v3H2C0.9,6,0,6.9,0,8v12c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V8c0-1.1-0.9-2-2-2h-4V3 c0-0.6-0.4-1-1-1H7z M16,6H8V4h8V6z M6,8c0-0.6-0.4-1-1-1S4,7.4,4,8v12c0,0.6,0.4,1,1,1s1-0.4,1-1V8z M20,8c0-0.6-0.4-1-1-1 s-1,0.4-1,1v12c0,0.6,0.4,1,1,1s1-0.4,1-1V8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M4,8c0-0.6,0.4-1,1-1s1,0.4,1,1v12c0,0.6-0.4,1-1,1s-1-0.4-1-1V8z M18,8c0-0.6,0.4-1,1-1s1,0.4,1,1v12 c0,0.6-0.4,1-1,1s-1-0.4-1-1V8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.71272f6c.svg";
export { ForwardRef as ReactComponent };